import { InitPage } from "../index";
import { snConfirm } from "./integrations";

class NetsuiteOauth2Certificate {
    private root: JQuery<HTMLElement>;
    private host: JQuery<HTMLElement>;
    private guide: JQuery<HTMLElement>;
    private opener: JQuery<HTMLElement> | null = null;
    private filename: string;

    constructor(root: JQuery<HTMLElement>) {
        this.root = root;
        this.host = root.closest(".ns-guide-host");
        this.guide = this.host.find<HTMLElement>("#netsuite-oauth2-guide").appendTo(this.host);
        this.filename = String(root.data("filename"));

        this.root.find<HTMLElement>("#netsuite-oauth2-generate").on("click", (e) => this.generate($(e.currentTarget)));
        this.root.find<HTMLElement>("#netsuite-oauth2-guide-open").on("click", (e) => this.openGuide($(e.currentTarget)));
        this.host.find("#netsuite-oauth2-download, #netsuite-oauth2-guide-download").on("click", (e) => {
            e.preventDefault();
            this.download();
        });
        this.guide.on("click", ".ns-guide-back", (e) => {
            e.preventDefault();
            this.closeGuide();
        });
        this.guide.on("keydown", (e) => {
            if (e.key !== "Escape") return;
            e.preventDefault();
            e.stopPropagation();
            this.closeGuide();
        });
        this.guide.find("#netsuite-oauth2-guide-done").on("click", () => {
            this.closeGuide();
            this.root.find("#integration_netsuite_oauth2_certificate_id").trigger("focus");
        });

        this.guide.find("#netsuite-oauth2-guide-filename").text(this.filename);
        this.toggleSubmit();
    }

    openGuide(opener: JQuery<HTMLElement>) {
        this.opener = opener;
        this.host.addClass("ns-guide-open");
        this.animate(this.guide, "int-slide-in");
        this.guide.find(".dlg-scroll").scrollTop(0);
        this.guide.find("button.ns-guide-back").first().trigger("focus");
    }

    closeGuide() {
        if (!this.host.hasClass("ns-guide-open")) return;
        this.host.removeClass("ns-guide-open");
        this.animate(this.host.children(":not(.ns-guide)"), "int-slide-back");
        if (this.opener) this.opener.trigger("focus");
    }

    animate(element: JQuery<HTMLElement>, className: string) {
        element.removeClass("int-slide-in int-slide-back");
        void element[0]?.offsetWidth;
        element.addClass(className);
    }

    pem(): string {
        return String(this.root.find("#netsuite-oauth2-certificate-pem").val() || "");
    }

    submit(): JQuery<HTMLElement> {
        return this.root.closest("form").find<HTMLElement>("[data-ns-submit]");
    }

    toggleSubmit() {
        this.submit().prop("disabled", !this.pem() || this.root.data("view-only") === true);
    }

    download() {
        const pem = this.pem();
        if (!pem) return;
        const url = URL.createObjectURL(new Blob([pem], { type: "application/x-pem-file" }));
        const link = document.createElement("a");
        link.href = url;
        link.download = this.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    async generate(button: JQuery<HTMLElement>) {
        if (this.pem()) {
            const confirmed = await snConfirm({
                title: "Generate a new certificate?",
                message: "The previous certificate will no longer be used, and its Certificate ID has to be replaced.",
                confirmText: "Generate",
                variant: "primary"
            });
            if (!confirmed) return;
        }

        const error = this.root.find("#netsuite-oauth2-generate-error");
        button.prop("disabled", true);
        error.prop("hidden", true);
        $.ajax({
            url: String(this.root.data("generate-url")),
            method: "POST",
            dataType: "json",
            headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") }
        }).done((data: any) => {
            this.filename = data.filename;
            this.root.find("#netsuite-oauth2-key-blob").val(data.key_blob || "");
            this.root.find("#netsuite-oauth2-certificate-pem").val(data.certificate_pem);
            this.host.find("#netsuite-oauth2-expires-at, #netsuite-oauth2-guide-expires-at").text(data.expires_at);
            this.guide.find("#netsuite-oauth2-guide-filename").text(data.filename);
            this.host.find("#netsuite-oauth2-certificate-status, #netsuite-oauth2-guide-file, #netsuite-oauth2-guide-validity").prop("hidden", false);
            this.guide.find("#netsuite-oauth2-guide-start").prop("hidden", true);
            button.find("span").text(String(this.root.data("generate-label")));
            this.root.find("#integration_netsuite_oauth2_certificate_id").val("");
            this.toggleSubmit();
            this.download();
            this.openGuide(button);
        }).fail((xhr: any) => {
            error.text(`Could not generate the certificate (${xhr.status}).`).prop("hidden", false);
        }).always(() => {
            button.prop("disabled", false);
        });
    }
}

function switchToTba(button: JQuery<HTMLElement>) {
    snConfirm({
        title: "Switch NetSuite back to TBA?",
        message: "Senitron uses the stored Token-Based Authentication credentials again. The OAuth 2.0 certificate is kept, so you can switch back later.",
        confirmText: "Switch to TBA",
        variant: "primary"
    }).then((confirmed) => {
        if (!confirmed) return;
        button.prop("disabled", true);
        const form = $("<form>", { method: "post", action: button.data("url") }).hide();
        form.append($("<input>", { type: "hidden", name: $('meta[name="csrf-param"]').attr("content"), value: $('meta[name="csrf-token"]').attr("content") }));
        $("body").append(form);
        form.trigger("submit");
    });
}

export function LoadPage() {
    InitPage("integrations", () => {
        $(document).on("click", ".js-netsuite-switch-tba", (e) => switchToTba($(e.currentTarget)));
        $(document).on("netsuite-oauth2:loaded", () => {
            const root = $("#netsuite-oauth2-certificate");
            if (root.length) new NetsuiteOauth2Certificate(root);
        });
        const renewOpen = $("#netsuite-oauth2-renew-open");
        if (renewOpen.length) $.ajax({ url: String(renewOpen.data("url")), dataType: "script" });
    });
}
